import apiNewton from "./apiNewton";

export const getStudentsAssistance = (params) => {
	return apiNewton.get("students/selectStudentsAssistancesByIdGroup", {
		params: params,
	});
};
